{
  "common": {
    "cancel": "Cancel"
  },
  "footer": {
    "terms": "Terms of use"
  },
  "nav": {
    "dashboard": "Dashboard",
    "sessions": "Charging History",
    "contracts": "Contracts",
    "subUsers": "Additional users",
    "admin": "Admin",
    "guide": "Guide",
    "logout": "Log out",
    "menu": "Menu"
  },
  "login": {
    "title": "Charging Portal",
    "identifier": "Email address",
    "placeholder": "firstname@email.fi",
    "userNotFound": "Email address not found. Please register first.",
    "sendCode": "Send code",
    "sending": "Sending…",
    "otpPrompt": "Enter the 6-digit code sent to",
    "codeExpires": "Code expires:",
    "verify": "Log in",
    "verifying": "Verifying…",
    "changeOrResend": "← Change address or request new code",
    "noAccount": "No account?",
    "register": "Register",
    "magicLinkExpired": "This login link has expired or already been used. Please log in with your email address.",
    "accountNotActive": "Your account is not yet active.",
    "guide": "Charging guide"
  },
  "register": {
    "title": "Register",
    "name": "Name",
    "email": "Email address",
    "phone": "Phone number (international format, e.g. +358401234567)",
    "apartment": "Apartment number",
    "registrationKey": "Registration key",
    "registrationKeyPlaceholder": "Enter the housing association registration key",
    "termsAccept": "I have read and accept the",
    "termsLink": "charging terms of service",
    "submit": "Continue",
    "submitting": "Sending verification code...",
    "hasAccount": "Already have an account?",
    "login": "Log in",
    "verifyTitle": "Verify your email",
    "otpSent": "We sent a 6-digit code to",
    "backToForm": "← Back to form",
    "successTitle": "Registration received",
    "successMessage": "The property manager will review your information and activate your account. You will be notified by email.",
    "backToLogin": "← Back to login",
    "parkingSpace": "Parking space number",
    "parkingSpacePlaceholder": "E.g. 12"
  },
  "validation": {
    "invalidEmail": "Invalid email address",
    "phoneTooShort": "Phone number is too short",
    "nameTooShort": "Name is too short",
    "apartmentRequired": "Apartment number is required",
    "registrationKeyRequired": "Registration key is required",
    "termsRequired": "You must accept the terms of service",
    "invalidRegistrationKey": "Invalid registration key."
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "wrongCode": "Wrong code. Please try again.",
    "wrongVerificationCode": "Wrong verification code. Check your email.",
    "tooManyAttempts": "Too many attempts. Request a new code.",
    "tooManyRequests": "Too many requests. Please wait before trying again.",
    "expired": "Code expired. Request a new one.",
    "expiredReturn": "Code expired. Go back and try again.",
    "emailAlreadyRegistered": "Email is already registered. Please log in.",
    "registrationFailed": "Registration failed.",
    "otpSendFailed": "Failed to send verification code. Please try again.",
    "accountNotActive": "Your account has not been activated yet. The property manager will activate it after registration."
  },
  "dashboard": {
    "loading": "Loading...",
    "sessionsCount": "Sessions",
    "energy": "Energy",
    "spotCost": "Spot energy",
    "marginCost": "Margin",
    "cost": "Total",
    "spotLabel": "spot",
    "marginLabel": "margin",
    "energyChart": "Monthly consumption",
    "costChart": "Monthly costs",
    "apartment": "Apartment",
    "phone": "Phone",
    "parking": "Parking space",
    "estimatedWarning": "Some prices are estimates (spot prices were not available at the time of calculation).",
    "monthlyChart": "Monthly consumption (kWh)",
    "chartTooltip": "Energy",
    "recentSessions": "Recent sessions",
    "noSessions": "No charging sessions yet.",
    "showAll": "Show all sessions →"
  },
  "sessions": {
    "loading": "Loading...",
    "noSessions": "No charging sessions yet.",
    "estimated": "est.",
    "loadingIntervals": "Loading breakdown...",
    "noIntervals": "Breakdown not available.",
    "time": "Time",
    "kwh": "kWh",
    "spot": "Spot",
    "margin": "Margin",
    "price": "Price",
    "startTime": "Charging started",
    "endTime": "Charging ended",
    "charger": "Charger",
    "activatedWith": "Activated with",
    "zaptecApp": "Zaptec app",
    "totalEnergy": "Energy",
    "energyCost": "Energy cost (spot)",
    "marginCost": "Margin",
    "totalCost": "Total",
    "spotLabel": "spot",
    "marginLabel": "margin",
    "sessionCount": "sessions",
    "presetCurMonth": "This month",
    "presetPrevMonth": "Last month",
    "presetCurQuarter": "This quarter",
    "presetPrevQuarter": "Last quarter",
    "presetLast30": "30 days",
    "presetAll": "All",
    "exportTitle": "Charging History",
    "print": "Print / save as PDF"
  },
  "contracts": {
    "title": "Contracts",
    "loading": "Loading...",
    "noContracts": "No contracts.",
    "primary": "Primary contract",
    "sub": "Sub-contract",
    "parking": "Parking space",
    "startDate": "Start date",
    "endDate": "End date",
    "active": "Active",
    "ended": "Ended",
    "end": "End contract",
    "endConfirm": "Contract will end on {{endDate}}. Do you want to continue?",
    "ended_success": "Contract ended",
    "description": "Charging sessions are assigned to your primary contract. A sub-contract is for additional parking spaces or vehicles you charge.",
    "subUsers": "Additional users",
    "addSubUser": "Add additional user",
    "subUserName": "Name",
    "subUserEmail": "Email",
    "removeSubUser": "Remove",
    "removeConfirm": "Remove this additional user?",
    "subUserAdded": "Additional user request sent",
    "subUserRemoved": "Additional user removed",
    "pendingApproval": "Pending approval",
    "requestNew": "Add new sub-contract",
    "requestPrimary": "Request new contract",
    "noPrimaryInfo": "You don't have an active primary contract. You can request a new contract from the property manager.",
    "requestSent": "Contract request sent",
    "requestParking": "Parking space number",
    "requestApartment": "Apartment"
  },
  "subUsers": {
    "title": "Additional users",
    "description": "An additional user gets a Zaptec login and charging access. Additional users cannot log in to this charging portal. Charging costs of additional users are billed to the primary account holder.",
    "loading": "Loading...",
    "noSubUsers": "No additional users.",
    "add": "Add additional user",
    "edit": "Edit",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "status": "Status",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "added": "Additional user added",
    "updated": "Additional user updated",
    "removed": "Additional user deactivated",
    "reactivated": "Additional user reactivated"
  },
  "admin": {
    "title": "Admin",
    "tabs": {
      "users": "Users",
      "contracts": "Contracts",
      "sessions": "Sessions",
      "pricing": "Pricing",
      "settings": "Settings",
      "parking": "Parking spaces",
      "stats": "Statistics",
      "reports": "Reports",
      "auditLog": "Audit log",
      "system": "System",
      "releasenotes": "Release notes"
    },
    "releasenotes": {
      "title": "Release notes",
      "empty": "No release notes yet",
      "new": "New release note",
      "newTitle": "Add release note",
      "editTitle": "Edit release note",
      "version": "Version (e.g. v1.2.3)",
      "releaseDate": "Release date",
      "titleLabel": "Title (optional)",
      "titlePlaceholder": "Short summary",
      "body": "Content",
      "save": "Save",
      "edit": "Edit",
      "delete": "Delete",
      "deleted": "Release note deleted",
      "saved": "Release note saved",
      "confirmDelete": "Delete {{version}}?",
      "releases": "releases"
    },
    "users": {
      "pendingTitle": "Pending activation",
      "activate": "Activate",
      "activeTitle": "Active users",
      "name": "Name",
      "email": "Email",
      "apartment": "Apartment",
      "roles": "Roles",
      "roleUser": "user",
      "roleAdmin": "admin",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "phone": "Phone",
      "status": "Status",
      "contractRole": "Contract",
      "primaryHolder": "Primary",
      "subUserOf": "Additional user ·",
      "createUser": "Add user",
      "createSubUser": "Add additional user",
      "noPrimaryContract": "User has no active primary contract",
      "createContract": "Create contract for user",
      "userCreated": "User created",
      "newRegistration": "New contract",
      "subUserRequest": "Additional user request",
      "userSaved": "User updated",
      "searchPlaceholder": "Search by name, email, apartment...",
      "placeholderDashIfNone": "use \"-\" if unknown",
      "errorNameRequired": "Name is required",
      "errorApartmentRequired": "Apartment number is required (use \"-\" if unknown)",
      "errorPhoneRequired": "Phone number is required (use \"-\" if unknown)"
    },
    "contracts": {
      "activeTitle": "Active contracts",
      "subContract": "Sub-contract",
      "primaryContract": "Primary contract",
      "apartment": "Apartment",
      "startDate": "From",
      "active": "active",
      "endedTitle": "Ended",
      "create": "Create new contract",
      "user": "User",
      "parkingSpace": "Parking space",
      "end": "End",
      "endConfirm": "Are you sure you want to end this contract?",
      "created": "Contract created",
      "ended": "Contract ended",
      "edit": "Edit contract",
      "saved": "Contract updated",
      "approve": "Approve",
      "approved": "Contract approved"
    },
    "sessions": {
      "count": "sessions",
      "time": "Time",
      "device": "Device",
      "kwh": "kWh",
      "price": "Price",
      "email": "Email",
      "token": "Token",
      "estimatedPrice": "Estimated price",
      "unlinked": "unlinked",
      "unlinkedTitle": "Unlinked charging sessions",
      "reassignAll": "Assign sessions",
      "reassignResult": "Assigned: {{reassigned}}, failed: {{failed}}",
      "searchPlaceholder": "Search by name, email or token…",
      "resync": "Re-fetch",
      "resyncFrom": "From",
      "resyncTo": "To",
      "resyncRun": "Fetch & calculate",
      "resyncResult": "{{count}} new sessions fetched"
    },
    "settings": {
      "userMgmt": "User management",
      "magicLinkAdmin": "Login link recipient",
      "magicLinkAdminAuto": "Automatic (first admin)",
      "magicLinkAdminHelp": "This admin user receives a one-time login link in notification emails.",
      "recipients": "Copy recipients (comma separated)",
      "emailName": "Name in emails",
      "billing": "Billing",
      "billingRecipients": "Billing recipients",
      "reportCopies": "Report copies",
      "technicalAlerts": "Technical alerts",
      "operationalAlerts": "Operational alerts",
      "alertRecipients": "Recipients",
      "boardStats": "Board statistics report",
      "boardStatsRecipients": "Recipients (comma-separated)",
      "boardStatsHelp": "Monthly summary of the statistics view, sent on the 1st of each month. Range: current year (in January, the previous year).",
      "marginTitle": "Price margin",
      "defaultMargin": "Default margin (cents/kWh)",
      "save": "Save",
      "saving": "Saving...",
      "saved": "Saved!",
      "saveFailed": "Save failed"
    },
    "wizard": {
      "title": "Activate user and create contract",
      "userInfo": "User information",
      "requestedParking": "Requested parking space",
      "parkingValid": "Parking space available",
      "parkingTaken": "Parking space already has a contract",
      "parkingNotFound": "Parking space not found in the system",
      "noParking": "Not specified",
      "configureContract": "Contract details",
      "confirm": "Confirm and activate",
      "activating": "Activating...",
      "success": "User activated and contract created",
      "reject": "Reject registration",
      "rejectConfirm": "Reject this registration? The user will not be able to log in.",
      "rejected": "Registration rejected"
    },
    "loading": "Loading...",
    "parking": {
      "title": "Parking spaces",
      "add": "Add parking space",
      "number": "Space number",
      "description": "Description",
      "user": "User",
      "status": "Status",
      "free": "Free",
      "created": "Parking space added"
    },
    "templates": {
      "tab": "Email templates",
      "selectTemplate": "Select template",
      "paramsTitle": "Available variables (copy into the message as-is):",
      "subject": "Subject",
      "body": "Message body",
      "saved": "Email template saved!",
      "saveFailed": "Saving failed.",
      "sendTest": "Send test",
      "testEmailPlaceholder": "test@email.com",
      "testSent": "Test email sent!",
      "testFailed": "Failed to send test email."
    },
    "stats": {
      "totalSessions": "Total sessions",
      "totalEnergy": "Total energy",
      "spotEnergy": "Spot energy",
      "billedEnergy": "Billed energy",
      "spotLabel": "spot",
      "marginLabel": "margin",
      "usersBilled": "Billed",
      "energyMargin": "Energy margin",
      "distribution": "distribution",
      "marginRevenue": "Margin revenue",
      "distributionCost": "Distribution + taxes",
      "baseFee": "Base fees",
      "costs": "costs",
      "grossMargin": "Gross margin",
      "contracts": "Contracts",
      "contractRevenue": "Contract revenue",
      "costBreakdown": "Housing association cost analysis",
      "month": "Month",
      "dateRange": "Date range",
      "clearFilter": "Clear",
      "avgPrice": "Avg. price",
      "presetPrevMonth": "Previous month",
      "presetCurMonth": "Current month",
      "presetCurYear": "Current year",
      "presetPrevYear": "Previous year",
      "presetAll": "All time",
      "monthlyTrend": "Monthly trend",
      "chargerBreakdown": "Charger breakdown",
      "utilization": "Utilization",
      "charger": "Charger",
      "sessions": "Sessions",
      "kwh": "kWh",
      "eur": "EUR"
    },
    "pricing": {
      "current": "Current pricing",
      "margin": "Charging margin",
      "distribution": "Distribution + taxes",
      "baseFee": "Base fee",
      "inclVat": "incl. VAT",
      "validFrom": "Valid from",
      "upcoming": "Upcoming pricing",
      "history": "Pricing history",
      "add": "Add new pricing",
      "contractFee": "Monthly contract fee",
      "saved": "Pricing saved"
    },
    "reports": {
      "title": "Reports",
      "quarter": "Quarter",
      "downloadCsv": "Download CSV",
      "downloadReport": "Download report",
      "preview": "Preview",
      "user": "User",
      "apartment": "Apartment",
      "sessions": "Sessions",
      "kwh": "kWh",
      "eur": "EUR",
      "parkingSpaces": "Parking spaces",
      "avgPrice": "Avg. price",
      "total": "Total"
    },
    "subUsers": {
      "title": "Additional users",
      "add": "Add additional user",
      "activate": "Activate",
      "name": "Name",
      "email": "Email",
      "status": "Status",
      "added": "Additional user added",
      "activated": "Additional user activated",
      "updated": "Additional user updated",
      "pending": "pending",
      "active": "active",
      "inactive": "inactive"
    },
    "system": {
      "ok": "OK",
      "error": "Error",
      "incomplete": "Incomplete",
      "outdated": "Outdated",
      "notConfigured": "Not configured",
      "lastSync": "Last sync",
      "failures": "Failures",
      "spotPrices": "spot prices",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "pricePoints": "price points",
      "backup": "Backup",
      "lastBackup": "Last backup",
      "files": "files",
      "email": "Email",
      "sender": "Sender",
      "database": "Database",
      "rows": "rows",
      "timers": "Scheduled tasks",
      "timerName": "Task",
      "timerInterval": "Interval",
      "timerAction": "Action",
      "timerDisabled": "Schedule disabled",
      "runNow": "Run now",
      "runConfirm": "Run \"{{name}}\" now?",
      "runSuccess": "{{name}} complete ({{ms}} ms)",
      "runResult": "Result: {{name}} ({{ms}} ms)",
      "runResultDetails": "Show details",
      "resolved": "Resolved",
      "serverTimeLabel": "Server time",
      "env": "Environment"
    },
    "auditLog": {
      "tab": "Audit log",
      "month": "Month",
      "eventType": "Event type",
      "all": "All",
      "time": "Time",
      "event": "Event",
      "actor": "Actor",
      "target": "Target",
      "details": "Details"
    }
  },
  "guide": {
    "title": "EV Charging Guide — Kilterinlinna",
    "toc": "Contents",
    "intro": "The parking hall charging stations are Zaptec devices. Charging requires the Zaptec app and a registered user account. This guide covers account setup, starting a charge, and using the charging portal.",
    "links": {
      "title": "Important links",
      "register": "Register as a charger",
      "login": "Sign in to the portal",
      "guide": "Guide",
      "terms": "Terms of use"
    },
    "contract": {
      "title": "Getting a charging contract",
      "step1": "Go to the charging portal",
      "step2": "Select Register",
      "step3": "Fill in your details: name, email, phone number, apartment number and parking space number",
      "step4": "Enter the housing association registration key (provided by the property manager)",
      "step5": "Verify your email by entering the code sent to your inbox",
      "step6": "The property manager will review and activate your account — you'll be notified by email"
    },
    "app": {
      "title": "Installing the Zaptec app",
      "intro": "Download the Zaptec app to your phone:"
    },
    "token": {
      "title": "Registering a charging token",
      "intro": "Charging requires a token registered in the Zaptec app. Supported tokens:",
      "nfc": "NFC tag card",
      "abloy": "Abloy Pulse key",
      "fob": "Building key fob",
      "multiple": "You can register multiple tokens for the same user.",
      "stepsTitle": "Token registration (done once per token)",
      "step1": "In the home view, select Account",
      "step2": "Select Zaptec keys from the menu",
      "step3": "Select Add Zaptec key",
      "step4": "Select the charger you are standing next to (e.g. B1) — check the number based on your parking space",
      "step5": "Give the token a descriptive name (e.g. \"Key fob\" or \"NFC card\") and press Next",
      "step6": "Hold the token against the charger reader following the animation",
      "step7": "Registration is complete",
      "video": "Watch video guide: Token registration"
    },
    "charging": {
      "title": "Charging",
      "withToken": "Starting a charge with a token",
      "tokenStep1": "Connect the charging cable to the station first, then to the vehicle",
      "tokenStep2": "Hold your registered token against the charger reader — wait for the beep",
      "tokenStep3": "The charger light will change color and charging will start",
      "withApp": "Starting a charge with the app",
      "appStep1": "Connect the charging cable to the station first, then to the vehicle",
      "appStep2": "Open the Zaptec app — press Authenticate",
      "appStep3": "Select your charger from the list",
      "appStep4": "When authentication is complete, press OK — charging starts",
      "appStep5": "You can pause and resume charging from the app by pressing Stop charging",
      "imgHome": "Start authentication",
      "imgChoose": "Select charger",
      "imgConfirmed": "Authentication complete",
      "imgStarted": "Charging in progress",
      "video": "Watch video guide: Starting a charge with the app",
      "stopTitle": "Stopping a charge",
      "stopStep1": "Disconnect the cable from the vehicle first, then from the charger",
      "stopStep2": "Charging also stops automatically when the battery is full",
      "cableWarning": "Leaving charging cables plugged into chargers without an active charging session is prohibited."
    },
    "cable": {
      "title": "Charging cable",
      "intro": "You need your own Type-2 to Type-2 charging cable (IEC 62196). The housing association does not provide cables.",
      "order": "Connect the cable to the charging station first, then to the vehicle",
      "lock": "The station connector locks automatically after authentication",
      "ce": "Only use undamaged, CE-marked cables"
    },
    "shared": {
      "title": "Shared use of charging stations",
      "intro": "Charging stations are shared by all users.",
      "cableReach": "You can use any free charging station that your own cable reaches from your own parking space. Vehicles are not moved to another space for charging.",
      "swapSpace": "If no charging station is within reach from your parking space, you can request a space swap from the maintenance company (asiakaspalvelu@myyrmaenhuolto.fi). Free spaces are swapped as needed.",
      "disconnect": "Disconnect the cable immediately when charging is complete or the vehicle is sufficiently charged",
      "noIdle": "Do not leave the cable connected unnecessarily — it prevents others from using the station",
      "dynamic": "Charging power (max. 11 kW/station) may be lower when multiple vehicles charge simultaneously — this is normal dynamic load management"
    },
    "safety": {
      "title": "Safety instructions",
      "inspect": "Inspect the cable before each use: do not use a damaged cable",
      "damaged": "Do not use a charging station that appears faulty — report the issue to the property manager",
      "tripping": "Make sure the cable does not cross walkways or create a tripping hazard",
      "vehicleFault": "Do not charge a vehicle with an apparent fault (oil leak, warning light)",
      "tamper": "Do not open, modify or damage the charging equipment",
      "emergencyTitle": "In an emergency (smoke, fire, electrical smell)",
      "emergency": "Disconnect the cable if safe to do so, leave the parking hall and call 112"
    },
    "costs": {
      "title": "Costs and billing",
      "monthlyFee": "Charging capability monthly fee",
      "monthlyFeeNote": "charged in addition to the parking space rent — charging capability is not included in the parking price",
      "energyFee": "Energy fee",
      "energyFeeDesc": "Electricity spot price + €0.11/kWh margin",
      "billingPeriod": "Billing period",
      "billingPeriodDesc": "Quarterly, billed in arrears",
      "spotInfo": "Spot prices vary hourly. The user is responsible for monitoring the current spot price — e.g. via sahkotin.fi or your energy provider's app.",
      "interval": "Prices are calculated in 15-minute intervals based on each interval's spot price.",
      "portalTitle": "Charging portal",
      "portalDesc": "In the charging portal you can view your charging history and cost breakdown: summary, session details with spot price and margin, and your contract information. Log in with your email address."
    },
    "troubleshoot": {
      "title": "Troubleshooting",
      "step1": "Check that authentication (app/NFC) was successful",
      "step2": "Check that the cable is securely connected to both the station and the vehicle",
      "step3": "Try a different charging station if available",
      "step4": "Report the issue to the property manager: state the station location (pillar number) and describe the problem"
    },
    "additional": {
      "title": "Additional users",
      "desc": "If a family member or another person needs charging access, you can add an additional user in the portal under Additional users. They will receive their own Zaptec credentials, but their charging costs are billed to the primary account holder."
    },
    "faq": {
      "title": "Frequently asked questions",
      "q2": "How much does charging cost?",
      "a2": "The price depends on the spot price at the time of charging. You can see a detailed breakdown in the charging portal. The association adds a margin according to the current pricing schedule.",
      "q3": "Can I charge at night for a lower price?",
      "a3": "Yes! Spot prices are typically lowest at night. You can schedule charging from your vehicle's settings. You can also pause charging from the app while the cable is connected and resume whenever you want.",
      "q4": "Who can see my charging data?",
      "a4": "You can see your own sessions in the portal. The property manager and board can see all sessions in the admin view for billing purposes."
    },
    "contact": {
      "title": "Contact",
      "billing": "Contracts and billing",
      "technical": "Technical issues with chargers",
      "emergencyLabel": "Emergencies",
      "terms": "The full contract text is in the document \"EV Charging Terms and Conditions\"."
    },
    "backToLogin": "← Back to login"
  },
  "stage": {
    "banner": "TEST ENVIRONMENT (STAGE) — this is not a production service —",
    "version": "version:"
  }
}
